export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "statuses.worker.7ed9d78aecc01e7732f3.worker.js");
}
